<template>
  <div class="ico_ul">
    <ul class=" clear">
      <li>
        <router-link
          :to="{
            name: 'first'
          }"
        >
          <p class="img"><img src="@/assets/images/h_ico01.png" /></p>
          <span>처음이세요?</span></router-link
        >
      </li>
      <li>
        <router-link
          :to="{
            name: 'vendor'
          }"
        >
          <p class="img"><img src="@/assets/images/h_ico02.png" /></p>
          <span>공급사 가이드</span></router-link
        >
      </li>
      <li>
        <router-link
          :to="{
            name: 'seller'
          }"
        >
          <p class="img"><img src="@/assets/images/h_ico03.png" /></p>
          <span>판매사 가이드</span></router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TopGuide'
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/layout/components/TopGuide.vue